import { DemoTag } from "@components/common/demo-tag";
import { FaroCardImage } from "@components/common/faro-card/faro-card-image";
import { BaseProjectProps } from "@custom-types/project-types";
import { Box } from "@mui/material";
import { unstyledLinkSx } from "@styles/common-styles";
import { defaultProjectThumbnail, isProjectDemo } from "@utils/project-utils";
import { Link } from "react-router-dom";

interface Props extends BaseProjectProps {
  /**
   * If provided, the thumbnail image is wrapped in a router Link pointing to this URL.
   */
  thumbnailLinkTo?: string;

  /** Called when the thumbnail link is clicked. */
  onThumbnailClick?: () => void;
}

/**
 * The top section of a card that shows the project thumbnail.
 */
export function ProjectCardTop({
  project,
  thumbnailLinkTo,
  onThumbnailClick,
}: Props): JSX.Element {
  const thumbnailImage = (
    <FaroCardImage
      src={project.thumbnailUrl ?? defaultProjectThumbnail}
      alt={project.name}
      // Don't translate the project name in the alt attribute
      shouldNotTranslate
      contextType="project"
      contextId={project.id}
    />
  );

  return (
    <>
      {thumbnailLinkTo ? (
        <Box
          component={Link}
          to={thumbnailLinkTo}
          onClick={onThumbnailClick}
          sx={unstyledLinkSx}
        >
          {thumbnailImage}
        </Box>
      ) : (
        thumbnailImage
      )}
      {/* If the project is a demo project shows a demo tag on the top left side */}
      {isProjectDemo(project) && (
        <DemoTag
          sx={{
            position: "absolute",
            top: "15px",
            left: "15px",
          }}
        />
      )}
    </>
  );
}
